<template>
    <div class="auth">
        <header class="auth__header header">
            <div class="header__container container-fluid">
                <div class="header__hlogo hlogo">
                    <img src="/images/logo-white-rus.svg">
                </div>
            </div>
        </header>

        <div class="auth-page__form auth-form text-center">
            <div class="auth-form__wrap">
                <div class="auth-form__title">DS Indoor Services</div>
                <div class="auth-form__subtitle">Документация</div>
                <div class="auth-form__form-group form-outline ">
                    <input type="email" id="form2Example1" placeholder="Логин" class="form-control form-control-lg" v-model="email" />
                </div>
                <div class="auth-form__form-group form-outline ">
                    <input type="password" id="form2Example2" placeholder="Пароль" class="form-control form-control-lg" v-model="password" />
                </div>

                <button type="button" class="auth-form__enter btn btn-primary" v-on:click="login()"><span>Войти</span></button>

                <a :href="route_password_request" class="auth-form__restore hover-underline">Забыли пароль?</a>
            </div>
        </div>
    </div>

    <Alert />

</template>

<script>
import Alert from "../alerts/Alert.vue";
import { mapMutations } from "vuex/dist/vuex.cjs.js";
import axios from "axios";

export default {
    name: "LoginComponent",
    components: { Alert },
    props: ['route_login', 'route_password_request', 'redirect'],
    data() {
        return {
            email: '',
            password: '',
            alertMessage: ''
        }
    },
    methods: {
        ...mapMutations('alerts', ['addAlert']),

        showError() {
            this.$refs.Error.showError()
        },

        login: async function () {
            const response = await axios.post('/login', {
                'email': this.email,
                'password': this.password
            }).then((response) => {
                return response.data
            });

            if (response.status == 'ok') {
                window.location.href = this.redirect;
            } else if (response.status == 'error') {
                this.addAlert({ type: 'error', title: 'Ошибка', text: response.message })
            }
        },
        interceptResponse() {
            window.lastResponse = null;
            axios.interceptors.response.use(response => {
                window.lastResponse = response;
                return response;
            }, error => {
                window.lastResponse = error.response;
                return Promise.reject(error);
            });
        },
    },
    mounted() {
        this.interceptResponse();
    }
}
</script>
